import React from 'react';
import { Icon } from '@iconify/react';

export interface SocialMediaLink {
  icon: string;
  href: string;
  label?: string;
}

interface SocialMediaLinksProps {
  links: SocialMediaLink[];
  iconClassName?: string;
  className?: string;
}

const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({
  links,
  iconClassName = 'w-5 h-5 text-text-secondary hover:text-primary-500 transition-colors duration-200',
  className = 'flex flex-row items-center space-x-4',
}) => {
  return (
    <div className={className}>
      {links.map((link, index) => (
        <a
          key={index}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="
            inline-flex items-center justify-center
            w-8 h-8
            focus-visible
            rounded-md
            hover:bg-surface-secondary
            transition-all duration-200 ease-in-out
          "
          aria-label={link.label || `Visit our ${link.icon.split(':')[1].split('-')[0]} page`}
        >
          <Icon icon={link.icon} className={iconClassName} />
        </a>
      ))}
    </div>
  );
};

export default SocialMediaLinks; 